// A product page switches to the redesigned layout when its content file is
// `format: 2` (docs/product-page.md). One switch for the whole page, never per
// section and never per product id. The loader guarantees format 2 has specs.
export const usesProductPageLayout = content => content?.format === 2;
